import React, { useContext, useEffect, useRef, useState } from 'react';
import {
  ClientDataSearchColumn, ClientDataSearchError, ClientDataButtoCalculate, ClientDataAddButton, ClientDataButtoCalculateButton,
  ClientDataTotal, ClientDataTotalPrice, ClientDataTotalTitle, ClientDataMontoTotal, ClientDataTotalData, ClientDataTotalDataMin,
  ClientDataTotalDataMinBlack, InfoCircleImage, Tooltip, TooltipContent, TooltipTitle, ClientDataHead, ClientDataHeadLabel, SimulatorConteinerButton, SimulatorSubSelectOficeLabelBlack
} from './styles';
import { useForm, Controller, useWatch } from 'react-hook-form';
import { SessionContext, LiquidacionPagosContext } from '../../../store';
import { Form, FormFooter, FormFooterRigth, FormRow } from '../../../components/FormTemplate/styles';
import Select from '../../../components/Select';
import InputIntl from '../../../components/InputIntl';
import { currencyMoney } from '../../../config/currency';
import { DefaultLargeButton, SecondaryLargeButton } from '../../../components/Buttons/styles';
import { StepFourDisplayValuesRow, StepFourDisplayValuesRowValue } from '../../Simulator/Result/styles';
import { StepFourColumn, StepFourDisplayValues, StepFourDisplayResultLabel } from './styles';
import { formatPrice } from '../../../helpers/price';
import { getAgileSimulatorCreditBound, getAgileSimulatorTasas, postAgileSimulatorResult } from '../../../services/agileSimulator';
import infoCircle from '../../../assets/images/info-circle.svg';
import InputDefault from '../../../components/InputDefault';
import Loader from '../../../components/Loader';
import ModalInfo from '../../../components/ModalInfo';
import { BsExclamation, BsCheck } from 'react-icons/bs';
import colors from '../../../assets/styles/colors';
import { Container, ContainerSinMargen, SimulatorSelectCaminoCedulaLabelBlack, SimulatorSelectOfficeImg, SimulatorSelectOficeLabel, SimulatorSelectOficeLabelBlack } from '../styles';
import SelectOfficeImg from '../../../assets/images/SelectOfficeImg.svg'
import InputPhone from '../../../components/InputPhone';
import { default as HabeasDataSenderTypes } from '../../../store/HabeasDataSender/types';
import InputFileBackGroundImage from "../../../components/InputFileBackGroundImage";
import { useDropzone } from 'react-dropzone';
import FormTemplate from "../../../components/FormTemplate";
import { habeasDataSenderSteps, pagosSteps } from '../../../helpers/enum';
import { enviarNotificacionCedulaHabeasData, enviarNotificacionHabeasData, getCedulaData, getObligatorieadadImagenesCedula } from '../../../services/habeasData';
import ModalActionSendIdValidation from '../../../components/ModalActionSendIdValidation';
import { useHistory } from 'react-router-dom';
import { toBase64 } from '../../../helpers/base64';
import ModalInfoImage from '../../../components/ModalInfoImage';
import descripcionCedula from '../../../assets/images/descripcionCargaCedula.svg';
import habeasdataImage from '../../../assets/images/modal-habeas-data.png'
import PdfView from '../../../components/PdfView';
import { postAceptarSettlement } from '../../../services/pagos';
import ModalActionText from '../../../components/ModalActionText';
import ModalAction from '../../../components/ModalAction';
import { ModalActionBodyIcon } from '../../../components/ModalAction/styles';

const PaymentSettlement = ({ setActiveStep, setLastStep }) => {
  const history = useHistory();
  const { liquidacionPagos, setLiquidacionPagos } = useContext(LiquidacionPagosContext);
  const session = useContext(SessionContext);
  const { register, handleSubmit, setValue, watch, control, clearErrors, errors } = useForm({});
  const fields = watch();
  const [isLoading, setIsLoading] = useState(false);
  const [showModalInfoError, setShowModalInfoError] = useState(false);
  const [titleError, setTitleError] = useState('');
  const [messageError, setMessageError] = useState('');
  const [showModalNotificacion, setShowModalNotificacion] = useState(false);
  const [messageModalNotificacion, setMessageModalNotificacion] = useState('');
  const [showModalNotificacionError, setShowModalNotificacionError] = useState(false);
  const [showModalInfoCedula, setShowModalInfoCedula] = useState(false);


  const [pageNumber, setPageNumber] = useState(1);
  const [scale, setScale] = useState(1.0);
  const [numPages, setNumPages] = useState(null);
  const pdfRef = useRef(null);
  const [pdfWidth, setPdfWidth] = useState("auto");
  const [showModalText, setShowModalText] = useState(false);
  const [aceptaPago, setAceptaPago] = useState(false);
  const [showModalAceptado, setShowModalAceptado] = useState(false);
  const [aceptaLiquidacion, setAceptaLiquidacion] = useState(false);

  async function aceptarPago(comentario) {
    try {
      setIsLoading(true);
      liquidacionPagos.settlement.comentario = comentario;
      if (!liquidacionPagos.twoSteps) {
        let data = {
          acceptance: true,
          documentNumber: liquidacionPagos.settlement.identificacion,
          documentId: 'CC',
          idAsesor: session.idAsesor,
          comment: comentario,
          dateTime: new Date().toISOString().slice(0, 19),
        }
        const response = await postAceptarSettlement(data);
        setMessageModalNotificacion('Su liquidación a sido aceptada')
        setIsLoading(false);
        setShowModalNotificacion(true)
        return
      }
      setActiveStep(pagosSteps.PLANILLA)
      setLastStep(pagosSteps.LIQUIDACION)
      setIsLoading(false);
    } catch (error) {
      console.log(error)
      setIsLoading(false);
    }
  }

  async function rechazarPago(comentario) {
    try {
      setIsLoading(true);
      let data = {
        acceptance: false,
        documentNumber: liquidacionPagos.settlement.identificacion,
        documentId: 'CC',
        idAsesor: session.idAsesor,
        comment: comentario,
        dateTime: new Date().toISOString().slice(0, 19),
      }

      const response = await postAceptarSettlement(data);
      setMessageModalNotificacion('Su liquidación a sido rechazada exitosamente')
      setShowModalNotificacion(true)
      setIsLoading(false);
    } catch (error) {
      console.log(error)
      setIsLoading(false);
    }

  }

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  function openModalText(e) {
    setAceptaPago(e);
    setShowModalText(true);
  }

  function openModalAceptar(e) {
    if (liquidacionPagos.twoSteps) {
      aceptarPago();
    } else {
      openModalText(true)
    }
  }

  function initializeStateComponent() {
    try {
      /*if (liquidacionPagos.settlement.aceptaLiquidacion) {
        setAceptaLiquidacion(true)
      }*/
    } catch (error) {
      console.log(error)
    }
  }

  function nextStep() {
    try {
      setActiveStep(pagosSteps.PLANILLA)
      setLastStep(pagosSteps.LIQUIDACION)
    } catch (error) {
      console.log(error)
    }
  }

 

  useEffect(() => {
    initializeStateComponent();
  }, [])

  const downloadPDF = () => {
    const base64String = liquidacionPagos.settlement.base64;
    const fileName = `liquidacion_${new Date().toISOString().slice(0, 10)}.pdf`; // Formato YYYY-MM-DD

    if (!base64String) {
      console.error("El archivo en base64 está vacío o no existe.");
      return;
    }

    const byteCharacters = atob(base64String);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "application/pdf" });
    const blobUrl = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = fileName; // Asigna el nombre dinámico aquí
    document.body.appendChild(link);
    link.click();

    URL.revokeObjectURL(blobUrl);
    document.body.removeChild(link);
  };


  useEffect(() => {
    if (pdfRef.current) {
      setPdfWidth(`${pdfRef.current.offsetWidth}px`);
    }
  }, [pdfRef.current]);

  return (
    <FormTemplate
      idForm="basic-data-step-page"
      activeStep={liquidacionPagos.twoSteps ? "1/2" : "1/1"}
      stepLabel="Liquidación de pago"
    >
      <Form>
        <div style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: colors.bgPrimary,

        }}>
          <div style={{ display: "flex", marginTop: '15px', alignItems: 'center'}}> 
          <ModalActionBodyIcon backgroundIcon={colors.yellow}>
          <BsExclamation size={32} color={colors.black} />
          </ModalActionBodyIcon>
          <p style={{margin: '5px'}}>
            Importante revisar la totalidad del documento mediante el botón descarga, y si estas deacuerdo del mismo Aceptalo.
          </p>
          </div>
          <div ref={pdfRef} style={{ width: "fit-content" }}>
            <PdfView
              pdf={liquidacionPagos.settlement.base64}
              pageNumber={pageNumber}
              scale={scale}
              numPages={numPages}
              onDocumentLoadSuccess={onDocumentLoadSuccess}
              setPageNumber={setPageNumber}
              setScale={setScale}
            />
          </div>
          <FormFooter justify="center" style={{ width: pdfWidth, display: "flex", marginTop: '5px' }}>
            <SecondaryLargeButton type="button" id="descargar" onClick={() => downloadPDF()}>Descargar</SecondaryLargeButton>
          </FormFooter>
          {(!liquidacionPagos.settlement.aceptaLiquidacion) &&
            <FormFooter justify="space-between" style={{ width: pdfWidth, display: "flex", marginBottom: '30px', marginTop: '0px' }}>
              <SecondaryLargeButton type="button" onClick={() => openModalText(false)}>Rechazar</SecondaryLargeButton>
              <SecondaryLargeButton type="button" onClick={() => openModalText(true)}>Aceptar</SecondaryLargeButton>
            </FormFooter>
          }
          {liquidacionPagos.settlement.aceptaLiquidacion && liquidacionPagos.twoSteps &&
            <FormFooter justify="space-between" style={{ width: pdfWidth, display: "flex", marginBottom: '30px', marginTop: '0px' }}>
              <div></div>
              <SecondaryLargeButton type="button" onClick={() => nextStep() }>Siguiente</SecondaryLargeButton>
            </FormFooter>
          }
        </div>

        {isLoading && <Loader></Loader>}
      </Form>
      <ModalInfo
        open={showModalInfoError}
        setShowModal={setShowModalInfoError}
        title={titleError}
        description={messageError}
        backgroundIcon={colors.bgDanger}
        bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />} />
      <ModalActionSendIdValidation
        open={showModalNotificacion}
        actionFunctionDownButton={() => history.push('/admin/dashboard')}
        actionLabelFunctionDownButton="Continuar"
        description={messageModalNotificacion}
        bodyIcon={<BsCheck id="message" size={32} color={colors.white} />}
        backgroundIcon={colors.textHyperlink} />
      <ModalActionSendIdValidation
        open={showModalNotificacionError}
        actionFunctionDownButton={() => setShowModalNotificacionError(false)}
        actionLabelFunctionDownButton="Continuar"
        description={messageModalNotificacion}
        bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />}
        backgroundIcon={colors.bgDanger} />
      <ModalInfoImage
        open={showModalInfoCedula}
        setShowModal={() => setShowModalInfoCedula(false)}
        description={messageModalNotificacion}
        bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />}
        backgroundIcon={colors.bgDanger}
        imgSource={habeasdataImage}
      />
      <ModalActionText
        open={showModalText}
        setShowModal={setShowModalText}
        actionFunctionDownButton={() => setShowModalText(false)}
        actionLabelFunctionDownButton="Aceptar"
        title={aceptaPago ? '' : 'Confirmación rechazo'}
        description={aceptaPago ? '¿Algo importante que quieras decirnos sobre tu proceso? Déjalo aquí, si no aplica, solo da clic en Aceptar' : 'Ingresa el motivo de rechazo de su liquidación y cuenta de cobro'}
        enviar={(comentario) => aceptaPago ? aceptarPago(comentario) : rechazarPago(comentario)}
        //campoRegister={}
        bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />}
        backgroundIcon={colors.darkGray} />

      <ModalAction
        open={showModalAceptado}
        setShowModal={setShowModalAceptado}
        actionFunctionUpButton={() => setShowModalAceptado(false)}
        description='Durante este mes ya has enviado los datos para pago.'
        actionLabelFunctionUpButton="Aceptar"
        backgroundIcon={colors.darkGray}
        bodyIcon={<BsExclamation size={32} color={colors.white} />} />
        
    </FormTemplate>
  )

}

export default PaymentSettlement
